import axiosClient from '../axiosClient';
import { DeliveryTypeEndpoints } from '../endpoints/deliveryType';
import { DeliveryTypeResponse } from '../../types/api/response/deliverytyperesponse';
import { UpdateDeliveryTypeRequest } from '../../types/api/request/deliverytyperequest';

export const DeliveryTypeService = {
  async listDeliveryTypes(): Promise<DeliveryTypeResponse[]> {
    const res = await axiosClient.get<DeliveryTypeResponse[]>(DeliveryTypeEndpoints.LIST);
    return res.data;
  },

  async getDeliveryType(id: number): Promise<DeliveryTypeResponse> {
    const url = DeliveryTypeEndpoints.GET.replace(':id', id.toString());
    const res = await axiosClient.get<DeliveryTypeResponse>(url);
    return res.data;
  },

  async updateDeliveryType(
    id: number,
    body: UpdateDeliveryTypeRequest,
  ): Promise<DeliveryTypeResponse> {
    const url = DeliveryTypeEndpoints.UPDATE.replace(':id', id.toString());
    const res = await axiosClient.put<DeliveryTypeResponse>(url, body);
    return res.data;
  },
};
